<template>
  <div id="left-menu" class="align-left">
    <p href="javascript:void(0)" class="closebtn pointer" @click="closeTrigger()">×</p>
    <div class="content">
      <ul class="category-list">
        <li
          v-for="(cat, index) in categories"
          :key="index"
          class="category-li"
          @click="toggleSubMenu(index)"
        >
          <span>{{ cat.name }}</span>
          <div v-show="showSubMenu === index" class="submenu-mobile">
            <left-submenu-view
              :category-id="cat._id"
              :subcategories="cat.children"
              :links="cat.links"
              @close="$emit('close')"
            />
          </div>
        </li>
      </ul>

      <div class="footer align-center">
        <!-- Account info buttons -->
        <div v-if="isEnabled('custome-accounts-enabled')">
          <div v-if="isSessionActive">
            <p @click="gotoOrders()">{{ $t('leftMenu.viewOrders') }}</p>
            <p @click="gotoAccount()">{{ $t('leftMenu.account') }}</p>
            <p @click="logoutClicked()">{{ $t('logout') }}</p>
          </div>
          <div v-else>
            <p @click="loginClicked()">{{ $t('login') }}</p>
          </div>
        </div>

        <!-- Contact button -->
        <p @click="gotoContact()">{{ $t('contact') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LeftSubmenuView from '@/components/LeftSubmenuView.vue';

export default {
  name: 'LeftMenuComponent',
  components: {
    LeftSubmenuView,
  },
  
  data() {
    return {
      showSubMenu: null,
    };
  },

  methods: {
    openCatalogPage(cat) {
      // this.$router.push(`/catalogs/${searchTerm}`);
      this.$router.push({
        path: '/search',
        query: {
          category: cat,
        },
      });
      this.$emit('close');
    },

    gotoOrders() {
      this.$router.push('/orders');
      this.$emit('close');
    },

    gotoAccount() {
      this.$router.push('/account')
      this.$emit('close');
    },

    gotoContact() {
      this.$router.push('/contact');
      this.$emit('close');
    },

    loginClicked() {
      this.$router.push('/login');
      this.$emit('close');
    },

    async logoutClicked() {
      try {
        await this.$store.dispatch('authStore/logout');
        this.$notify({
          group: 'all',
          type: 'success',
          text:this.$t('successLogout') ,
        });
        this.$store.commit('cartStore/resetOrders');
        this.$store.commit('shippingStore/resetAddresses');
        this.$router.push('/');
      } catch (err) {
        this.$notify({
          group: 'all',
          type: 'error',
          text: this.$t('errLogout'),
        });
      }
      this.$emit('close');
    },
    closeTrigger(){
      this.showSubMenu = null;
      this.$emit('close');
    },
    toggleSubMenu(index) {
      this.showSubMenu = this.showSubMenu === index ? null : index;
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.showSubMenu = null;
    next();
  },

  computed: {
    ...mapGetters({
      isSessionActive: 'authStore/isSessionActive',
      categories: 'categoryStore/categories',
      isEnabled: 'featureFlagStore/isEnabled'
    }),
  },
};
</script>

<style lang="scss">
@import '@/assets/css/constants.scss';
#left-menu {
  .content {
    font-size: 1.25rem;

    .category-list {
      min-height: 65vh;
      max-height: 65vh;
      overflow-x: hidden;
      overflow-y: scroll;
      padding: 0;

      .category-li {
        border-bottom: 0.5px solid #dbdbdb;
        list-style-type: none;
        padding: 1rem 1.5rem;
        cursor: pointer;
        list-style-type: none;
      }
    }

    .footer {
      position: absolute;
      bottom: 0;
      right: 0;
      left: 0;
      height: 20vh;
      margin-bottom: 0;
      padding-top: 1rem;
      background-color: darken($color: whitesmoke, $amount: 5);

      p {
        cursor: pointer;
      }
    }
    
    .submenu-mobile{
      margin-top: 25px;

      a {
        padding: 0px !important;
        margin: 0px !important;
        font-size: 1rem !important;
      }

      ul {
        padding: 0px;
        list-style-type: none;
      }

      li {
        margin-bottom: 5px;
        margin-top: 5px;
      }

      .subcategories {
        a {
          color: rgba(34,34,34,.7) !important;
        }
      }

      .cat-links {
        a {
          color: $link-color !important;
          text-decoration: underline !important;
        }
      }
    }
  }
}
</style>
